import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getSynch,
  getExport,
} from "./adjustmentStockAPI";

const initialState = {
  data: [],
  stock: null,
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "adjustmentStock/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchStock = createAsyncThunk(
  "adjustmentStock/fetchStock",
  async (id) => {
    const response = await getSynch(id);
    return response;
  }
);
export const fetchIdNoloading = createAsyncThunk(
  "adjustmentStock/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);
export const fetchId = createAsyncThunk(
  "adjustmentStock/fetchId",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk(
  "adjustmentStock/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "adjustmentStock/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "adjustmentStock/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const fetchExport = createAsyncThunk(
  "adjustmentStock/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const adjustmentStockSlice = createSlice({
  name: "adjustmentStock",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchStock.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStock.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = adjustmentStockSlice.actions;

export const selectData = (state) => state.adjustmentStock.data;
export const selectId = (state) => state.adjustmentStock.dataId;
export const selectStock = (state) => state.adjustmentStock.dataStock;
export const selectLoading = (state) => state.adjustmentStock.loading;
export const selectError = (state) => state.adjustmentStock.error;
export const selectPageNo = (state) => state.adjustmentStock.pageNo;
export const selectPageSize = (state) => state.adjustmentStock.pageSize;
export const selectTotalRecord = (state) => state.adjustmentStock.totalRecord;
export const selectSelected = (state) => state.adjustmentStock.selected;
export const selectResult = (state) => state.adjustmentStock.result;

export default adjustmentStockSlice.reducer;
